<template>
  <b-card>
    <delete-pricing-modal
      :pricing="toBeDeletedOverride"
      @deleted="getPricingOverrides"
    />
    <base-overlay :show="fetching">
      <b-button
        v-if="$can('write', 'pricing-override')"
        class="mb-2"
        variant="primary"
        to="/pricing-overrides/new"
      >
        Add pricing override
      </b-button>
      <b-table
        :items="pricingOverridesList"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching pricing overrides found"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="$can('write', 'pricing-override')"
              :to="{
                name: 'edit-pricing-overrides',
                params: { id: data.item.group },
              }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('delete', 'pricing-override')"
              @click="deletePopupHandler(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template></b-table>
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BTable, BButton, BCard, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import pricingOverridesStore from '../store'
import usePricingOverridesList from '../hooks/usePricingOverridesList'
import deletePricingModal from '../components/DeleteModal.vue'

export default {
  components: {
    BTable,
    deletePricingModal,
    BButton,
    BCard,
    BDropdown,
    BDropdownItem,
  },
  setup(_, ctx) {
    useRegisterStoreModule('pricing-override', pricingOverridesStore)
    return {
      ...usePricingOverridesList(ctx),
    }
  },
}
</script>

  <style>

  </style>
